// extracted by mini-css-extract-plugin
export default {"container":"comingSoon_container__a0ijU","icon":"comingSoon_icon__V1QAN"};